import { InjectionToken } from '@angular/core';

export type PortalMode = 'tenant' | 'platform';

export const PORTAL_MODE = new InjectionToken<PortalMode>('PORTAL_MODE', {
  providedIn: 'root',
  factory: () => 'tenant',
});

